import {success, invalid, failure} from "./helpers";
import {
  GET_STATES,
  GET_TIMEZONE,
  GET_COMPANY_LOGO,
  UPDATE_PROFILE,
  SET_STATUS,
  GET_PHOTO,
  UPDATE_LOGO,
  UPDATE_PHOTOT,
  CHANGE_PASSWORD
} from "../actions/Profile";

const initialState = {
  data: [],
  allstates: [],
  timezone: [],
  company_logo: '',
  photo: '',
  ifUpdateSuccess: false,
  update_error_message: '',
  update_logo_msg: '',
  update_photo_msg: '',
  change_password_error_msg: ''
};

export const myProfile = (state=initialState, action) => {
  switch(action.type) {
    case success(GET_STATES):
      return {
        ...state,
        allstates: action.payload
      }
    case success(GET_TIMEZONE):
      return {
        ...state,
        timezone: action.payload
      }

    case success(GET_COMPANY_LOGO):
      return {
        ...state,
        company_logo: action.payload
      }

    case success(GET_PHOTO):
      return {
        ...state,
        photo: action.payload
      }
    case success(UPDATE_PROFILE):
      return {
        ...state,
        ifUpdateSuccess: true,
        update_error_message: ''
      }
    case invalid(UPDATE_PROFILE):
      return {
        ...state,
        ifUpdateSuccess: false,
        update_error_message: action.payload.message
      }
    case SET_STATUS:
      return {
        ...state,
        ifUpdateSuccess: action.value
      }
    case success(UPDATE_LOGO):
      return {
        ...state,
        ifUpdateSuccess: true,
        update_logo_msg: ''
      }
    case invalid(UPDATE_LOGO):
      return {
        ...state,
        update_logo_msg: action.payload.message
      }
    case failure(UPDATE_LOGO):
      return {
        ...state,
        update_logo_msg: action.payload.message
      }
    case success(UPDATE_PHOTOT):
      return {
        ...state,
        ifUpdateSuccess: true,
        update_photo_msg: ''
      }
    case invalid(UPDATE_PHOTOT):
      return {
        ...state,
        update_photo_msg: action.payload.message
      }
    case failure(UPDATE_PHOTOT):
      return {
        ...state,
        update_photo_msg: action.payload.message
      }
    case success(CHANGE_PASSWORD):
      return {
        ...state,
        ifUpdateSuccess: true,
        change_password_error_msg: ''
      }
    case invalid(CHANGE_PASSWORD):
      return {
        ...state,
        change_password_error_msg: action.payload.message
      }
    case failure(CHANGE_PASSWORD):
      return {
        ...state,
        change_password_error_msg: action.payload.message
      }
    default:
      return state;
  }
}

export default {
  myProfile
}


// WEBPACK FOOTER //
// ./src/reducers/profile.js